import { render, staticRenderFns } from "./BaseTipTapEditor.vue?vue&type=template&id=3cceb7d3"
import script from "./BaseTipTapEditor.vue?vue&type=script&lang=js"
export * from "./BaseTipTapEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseTipTapEditor.vue?vue&type=style&index=0&id=3cceb7d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports